<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap docs">
          <h1>Настройка состава полей</h1>

          <div class="docs-table">
            <table>
              <tr>
                <th class="doc-title">Название</th>
                <th class="doc-title">Раздел</th>
                <th class="doc-title">Формат поля</th>
                <th class="doc-title">Флаги</th>
                <th class="doc-title">Целевые категории</th>
                <th class="doc-del"></th>
              </tr>
              <tr v-for="(field, fieldIndex) in config.fields" :key="'field' + fieldIndex">
                <td><v-text-field v-model="field.name" :disabled="fieldIndex<lockedParamsNumber"></v-text-field></td>
                <td class="doc-checkbox doc-checkbox__wide">
                  <v-text-field v-model="field.section" :disabled="fieldIndex<lockedParamsNumber"></v-text-field>
                </td>
                <td>
                  <v-autocomplete
                      dense
                      :disabled="fieldIndex<lockedParamsNumber"
                      :items="getDatatypes()"
                      @change="onDatatypeChange(field, $event)"
                      item-value="id"
                      v-model="field.type"
                  ></v-autocomplete>
                  <a href="#" v-if="field.type?.startsWith('dict_')" @click.prevent="openCreateDictDialog(field, field.type)">Редактировать справочник</a>
                </td>
                <td class="doc-checkbox doc-checkbox__wide">
                  <v-checkbox
                      v-model="field.multiple"
                      :disabled="fieldIndex<lockedParamsNumber"
                      label="Множественность"
                  />
                  <v-checkbox
                      v-model="field.show"
                      :disabled="fieldIndex<lockedParamsNumber"
                      label="Отображение в кат."
                  />
                  <v-checkbox
                      v-model="field.public"
                      :disabled="fieldIndex<lockedParamsNumber"
                      label="Публичность"
                  />
                </td>
                <td>
                  <v-autocomplete
                      dense
                      :disabled="fieldIndex<lockedParamsNumber"
                      :items="categories"
                      v-model="field.categories"
                      multiple
                      chips
                  ></v-autocomplete>
                </td>
                <td v-if="fieldIndex<lockedParamsNumber"></td>
                <td v-else class="doc-del" style="cursor: pointer" @click="deleteField(fieldIndex)"></td>
              </tr>
            </table>
          </div>

          <div class="doc-add">
            <a href="#" @click.prevent="addField()">Добавить поле</a>
          </div>
          <div class="buttons">
            <v-btn
                class="btn btn-outline"
                text
                @click="$router.push('/')"
            >
              Отмена
            </v-btn>
            <v-btn
                class="btn btn-primary"
                @click="submit()"
            >
              Сохранить изменения
            </v-btn>
          </div>
        </div>
        <v-dialog
            v-model="editDictDialog"
            max-width="1000px"
            persistent>
          <template v-slot:activator="{ on }">
            <div v-on="on">
            </div>
          </template>
          <EditDictDialog
              :config="config"
              :dict="dictToEdit"
              v-if="editDictDialog"
              @close="onEditDictDialogClose"
          ></EditDictDialog>
        </v-dialog>

        <div v-if="errorText!=null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
  </div>
</template>

<script>

import {categories, loadConfig, saveConfig, uuidv4} from "@/modules/services";
import EditDictDialog from "@/components/dialogs/EditDictDialog";

export default {
  name: 'ConfigComponent',
  components: {EditDictDialog},

  data: () => ({
    config: {},
    lockedParamsNumber: 0,
    values: {},
    categories: categories,
    apiLoaded: false,
    errorText: null,
    dialog: false,
    editable: false,
    editDictDialog: false,
    dictToEdit: undefined,
    editDictTriggeredField: undefined,
    basicDatatypes: [
      {id: 'NUMBER', text: ' Число'},
      {id: 'STRING', text: 'Строка'},
      {id: 'DATE', text: 'Дата'},
      {id: 'FILES', text: 'Файлы'},
      {id: 'LINK', text: 'Ссылка'},
    ]
  }),

  methods: {
    getDatatypes(){
      let datatypes = JSON.parse(JSON.stringify(this.basicDatatypes))
      if(this.config.dicts){
        for(let dict of this.config.dicts){
          datatypes.push({id: dict.id, text: dict.name + ' (справочник)'})
        }
      }

      datatypes.push({id: 'CREATE_DICT_OPTION', text: 'Создать справочник'})
      return datatypes
    },

    onDatatypeChange(triggeredField, value){
      if(value === 'CREATE_DICT_OPTION'){
        this.openCreateDictDialog(triggeredField)
      }
    },

    onEditDictDialogClose(createdDict){
      this.editDictDialog=false;
      if(createdDict){
        this.editDictTriggeredField.type = createdDict.id
      } else {
        this.editDictTriggeredField.type = this.basicDatatypes[0].id
      }
      this.$forceUpdate()
    },

    openCreateDictDialog(triggeredField, dictIdToEdit){
      this.editDictTriggeredField = triggeredField
      if(dictIdToEdit){
        this.dictToEdit = this.config.dicts?.find(e=>e.id===dictIdToEdit)
      } else {
        this.dictToEdit = null
      }
      this.editDictDialog = true
    },


    addField(){
      this.config.fields.push({
        id: uuidv4(),
        name: '',
        categories: categories.map(e=>e.value),
        show: false,
        public: false
      })
    },


    deleteField(index){
      this.config.fields.splice(index, 1)
      this.$forceUpdate()
    },

    async submit(){
      await saveConfig(this.config)
      this.$router.push('/')
    }
  },

  filters: {},

  async beforeMount() {
    this.config = await loadConfig()
    this.apiLoaded = true;
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>
